import 'antd/lib/style';
import './index.less';

// style dependencies
import 'antd/lib/empty/style';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@whalecloud/fdx-theme-fdx/select/index.tsx
// module id = 1303
// module chunks = 0